export default {
    '1': {
        text: 'Ben je ernstig moe?',
    },
    'VVV': {
        explanation: 'Je twijfelt of je ernstig moe bent. Op basis van de volgende vragen kan de ernst van je vermoeidheid worden ingeschat. Vul de vragen in.',
        statements: {
            '1': {
                text: 'Ik voel me moe.',
            },
            '2': {
                text: 'Ik ben gauw moe.',
            },
            '3': {
                text: 'Ik voel me fit.',
            },
            '4': {
                text: 'Lichamelijk voel ik me uitgeput.',
            },
        },
    },

    '2': {
        text: 'Ben je langer dan 6 maanden moe?',
    },
    '2-A': {
        text: 'Is de moeheid ontstaan rond het stellen van de diagnose of tijdens de behandeling van kanker?',
    },
    '2-A1': {
        text: 'Ben je op dit moment onder behandeling voor kanker?',
        explanation: 'Als je onderhoudsbehandeling of hormoontherapie krijgt antwoord dan nee op deze vraag.',
    },
    '2-A2': {
        text: 'Is je behandeling voor kanker korter dan 6 maanden geleden afgerond?',
    },
    '2-B': {
        text: 'Ben je op dit moment ziek of heb je lichamelijke klachten en verwacht je binnen afzienbare termijn te herstellen?',
        explanation: 'Denk bijvoorbeeld aan griep,  een longontsteking of herstel van een operatie die mogelijk de moeheid kan verklaren.',
    },
    '2-B1': {
        text: 'Was je voordat je ziek was al moe?',
    },
    '2-C': {
        text: 'Heb je een chronische ziekte waarbij vermoeidheid vaak voorkomt?',
        explanation: 'Denk bijvoorbeeld aan diabetes, COPD, reuma of multiple sclerose.',
    },
    '2-D': {
        text: 'Ben je jonger dan 18 jaar?',
    },

    '3': {
        text: 'Heeft een arts gekeken naar een mogelijke lichamelijke oorzaak van je vermoeidheid?',
    },

    '4': {
        text: 'Is de moeheid ontstaan rond het stellen van de diagnose of tijdens de behandeling van kanker?',
    },
    '4-A': {
        text: 'Ben je op dit moment nog onder behandeling voor kanker?',
        explanation: 'Als je onderhoudsbehandeling of hormoontherapie krijgt antwoord dan nee op deze vraag.',
    },
    '4-B': {
        text: 'Is je behandeling voor kanker korter dan 6 maanden geleden afgerond?',
    },

    '5': {
        text: 'Ben je op dit moment ziek of heb je lichamelijke klachten en verwacht je binnen afzienbare termijn te herstellen?',
        explanation: 'Denk bijvoorbeeld aan griep, een longontsteking of herstel van een operatie die mogelijk de moeheid kan verklaren.',
    },
    '5-A': {
        text: 'Had je voordat je ziek werd of lichamelijke klachten kreeg al last van ernstige vermoeidheid?',
    },

    '6': {
        text: 'Heb je een chronische ziekte waarbij vermoeidheid vaak voorkomt?',
        explanation: 'Denk bijvoorbeeld aan diabetes, COPD, reuma of multiple sclerose.',
    },

    '7': {
        text: 'Ben je jonger dan 18 jaar?',
    },
    '7-A': {
        subquestions: {
            '1': {
                text: 'Ga je door de moeheid minder of niet naar school',
            },
            '2': {
                text: 'Zie je je vrienden minder vaak?',
            },
            '3': {
                text: 'Sport je minder?',
            },
        },
    },

    '8': {
        text: 'Ben je momenteel onder behandeling van een psychiater of psycholoog?',
        explanation: 'Bijvoorbeeld in verband met een andere klacht dan moeheid, zoals somberheid of angst.',
    },
    'SAL': {
        explanation: 'Veel mensen die al lange tijd ernstig moe zijn worden hierdoor beperkt in hun dagelijks leven. De volgende vragen gaan over de beperkingen die je ervaart door je vermoeidheid.',
        statements: {
            '1': {
                text: 'Ik word beperkt in mijn vermogen om te werken.',
            },
            '2': {
                text: 'Ik word beperkt in de uitvoering van de taken thuis.',
                explanation: 'Bijvoorbeeld zorg voor de kinderen, administratie, schoonmaken, winkelen, koken.',
            },
            '3': {
                text: 'Ik word beperkt in sociale activiteiten en mijn vrije tijdsbesteding met anderen.',
                explanation: 'Bijvoorbeeld uitstapjes, op bezoek gaan, feestjes.',
            },
            '4': {
                text: 'Ik word beperkt in activiteiten in mijn vrije tijd die ik alleen doe.',
                explanation: 'Bijvoorbeeld lezen, tuinieren, wandelen, internetten.',
            },
            '5': {
                text: 'Ik word beperkt in het aangaan en onderhouden van mijn contacten en relaties.',
            },
        },
    },
};
